import isPropValid from '@emotion/is-prop-valid'
import { media } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import { IAttributes } from 'app/components/CustomBlocks/layout/SectionBlock/Attributes'

const SectionBlockComponent: React.FC<React.PropsWithChildren<IAttributes>> = (props) => (
  <Wrapper {...props}>{props.children}</Wrapper>
)

const Wrapper = styled.div.withConfig({ shouldForwardProp: isPropValid })<IAttributes>`
  overflow-x: hidden;

  @media ${media.largeDesktop} {
    padding-top: ${(props) => props?.largeDesktopTopSpacing || 0}px;
    padding-bottom: ${(props) => props?.largeDesktopBottomSpacing || 0}px;
  }
  @media ${media.desktop} {
    padding-top: ${(props) => props?.desktopTopSpacing || 0}px;
    padding-bottom: ${(props) => props?.desktopBottomSpacing || 0}px;
  }
  @media ${media.tablet} {
    padding-top: ${(props) => props?.tabletTopSpacing || 0}px;
    padding-bottom: ${(props) => props?.tabletBottomSpacing || 0}px;
  }
  @media ${media.mobile} {
    padding-top: ${(props) => props?.mobileTopSpacing || 0}px;
    padding-bottom: ${(props) => props?.mobileBottomSpacing || 0}px;
  }
`

export default SectionBlockComponent
